module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/03-02.eed462be.mp3";